import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import m21Ratings from "../../../../src/data/articles/cube-prospective-core-set-2021/m21-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  m21Ratings,
  ProspectiveIntro,
  React
};